<template>
    <div>
        <div class="coaches flx" v-if="list.length > 0">
            <div class="coachItem" :style="(index + 1) % 4 == 0?'margin-right: 0' :'margin-right:50px' "
                v-for="item,index in list" @click="toDetail(item)">
                <div class="coachImg">
                    <img :src="$img(item.avatar)" alt="" />
                </div>
                <div class="coachInfo">
                    <div class="coachName multy2" v-html="setRedText(item.goods_name,keyword)"></div>
                    <div class="price-wrap">
                        <!-- 价格组件 -->
                        <span class="price-box">
                            <span>¥</span>
                            <span class="int">{{p(item.default_goods_price,0) }}</span>
                            <span class="dec">{{p(item.default_goods_price,1) }}</span>
                        </span>
                    </div>
                    <div class="booktips single" v-text="item.title"></div>
                </div>
            </div>
        </div>
        <div v-else style="box-sizing: border-box;padding-top: 100rpx;">
            <img :src="$Localimg('nosearch.png')" class="nodatas" alt="">
        </div>
    </div>
    
</template>

<script>
    export default {
        name: "jobsearch",
        props: {
            list: Array,
            keyword: String
        },
        data() {
            return {};
        },
        created() {
            let that = this
        },
        methods: {
            toDetail(e){
                this.$router.push({
                    path: '/bookDetail', // 写路由path
                    query: {
                        id: e.goods_id
                    }
                })
            },
            setRedText(text, key) {
                if (!key) return text;
                // 正则g全局匹配，忽略大小写加i
                const reg = new RegExp(key, "g");
                // 替换为红色span标签
                return text.replace(reg, `<span style="color:red">${key}</span>`);
            },
            p(e, d) {
                const s = Number(e).toFixed(2).split('.')
                let p = {}
                p.int = s[0]
                p.dec = '.' + s[1]
                return d == 0 ? s[0] : '.' + s[1]
            },
        }
    };
</script>

<style scoped>
    .codename{
        font-size: 12px;
        color: #666666;
        text-align: center;
    }
    .codeImg{
        width: 84px;
        height: 84px;
    }
    .codeImg img{
        width: 100%;
        height: 100%;
    }
    .codeItem{
        background: #fff;
        box-sizing: border-box;
        padding: 16px;
    }
    .advItem{
        width: 100%;
        height: 138px;
        margin-bottom: 20px;
        cursor: pointer;
        object-fit: cover;
    }
    .advItem img{
        width: 100%;
        height: 100%;
        border-radius: 8px;
    }
    .advs{
        width: 244px;
        box-sizing: border-box;
        padding-top: 17px;
    }
    .reRight{
        width: 88px;
        height: 36px;
        background: #007AFF;
        border-radius: 3px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        color: #FFFFFF;
        cursor: pointer;
    }
    .comTop img{
        width: 22px;
        height: 22px;
        margin-right: 8px;
    }
    .comTop div{
        font-size: 16px;
        color: #222222;
    }
    .rlb{
        font-size: 14px;
        color: #555C70;
    }
    .rlabel{
        height: 23px;
        background: #F5F7FA;
        border-radius: 2px;
        font-size: 12px;
        color: #555C70;
        line-height: 23px;
        padding: 0 9px;
        margin: 12px 0;
        margin-right: 10px;
    }
    .rsalary{
        font-weight: 500;
        font-size: 18px;
        color: #007AFF;
    }
    .rname{
        font-weight: 600;
        font-size: 18px;
        color: #000000;
        margin-right: 14px;
    }
    .reLeft{
        width: 440px;
        
    }
    .reItemm{
        margin: 0 auto;
        background: #fff;
        border-radius: 10px;
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
        margin-top: 16px;
        width: 926px;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #D9D9D9;
    }
    .reItemns{
        width: 100%;
    }
    .labelName{
        height: 29px;
        background: linear-gradient( 79deg, #F59E0B 0%, #F4870A 100%);
        border-radius: 15px 15px 15px 2px;
        box-sizing: border-box;
        padding: 0 11px;
        line-height: 29px;
        position: absolute;
        left: 12px;
        top: 12px;
        font-weight: 600;
        font-size: 13px;
        color: #FFFFFF;
    }
    .reImg {
        width: 344px;
        height: 194px;
        position:relative;
        
    }
    
    .reimgMask{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 3;
        background-color: rgba(0, 0, 0, .5);
    }
    
    .reimgMask img{
        width: 56px !important;
        height: 56px !important;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
    
    .reImg img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
    .rebtn {
        width: 104px;
        height: 36px;
        background: linear-gradient(90deg, #4A9EFF 0%, #1E7FE5 100%);
        box-shadow: 0px 2px 6px 0px rgba(30, 127, 229, 0.25);
        border-radius: 18px;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        line-height: 36px;
    }
    
    .reTitle {
        font-weight: 500;
        font-size: 14px;
        color: #9CA3AF;
        margin-top: 10px;
    }
    
    .reInfo {
        box-sizing: border-box;
        padding: 20px;
        text-align: left;
    }
    
    .reName {
        height: 48px;
        line-height: 24px;
        width: 100%;
        font-weight: 600;
        font-size: 16px;
        color: #000000;
    }
    
    .relist {
        flex-wrap: wrap;
        justify-content: space-between;
        box-sizing: border-box;
        padding-bottom: 56px;
    }
    
    .reItem {
        width: 344px;
        height: 372px;
        background: #FFFFFF;
        box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        margin-bottom: 28px;
        overflow: hidden;
        margin-right: 28px;
        position: relative;
        cursor: pointer;
    }
    
    .listCon {
        box-sizing: border-box;
        padding: 10px 30px;
    }
    .reImg {
        width: 344px;
        height: 194px;
    }
    
    .reImg img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
    .rebtn {
        width: 104px;
        height: 36px;
        background: linear-gradient(90deg, #4A9EFF 0%, #1E7FE5 100%);
        box-shadow: 0px 2px 6px 0px rgba(30, 127, 229, 0.25);
        border-radius: 18px;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        line-height: 36px;
    }
    
    .reTitle {
        font-weight: 500;
        font-size: 14px;
        color: #9CA3AF;
        margin-top: 10px;
    }
    
    .reInfo {
        box-sizing: border-box;
        padding: 20px;
        text-align: left;
    }
    
    .reName {
        height: 48px;
        line-height: 24px;
        width: 100%;
        font-weight: 600;
        font-size: 16px;
        color: #000000;
    }
    
    .relist {
        flex-wrap: wrap;
        box-sizing: border-box;
        padding-bottom: 56px;
        box-sizing: border-box;
        padding: 10px 30px;
    }
    
    .reItem {
        width: 344px;
        height: 372px;
        background: #FFFFFF;
        box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        margin-bottom: 28px;
        overflow: hidden;
        position:relative;
        margin-right: 28px;
    }
    .booktips {
        font-weight: 500;
        font-size: 12px;
        color: #9CA3AF;
        margin-top: 6px;
    }

    .price-box {
        display: inline-flex;
        align-items: baseline;
        color: #FF0F23;
    }

    .int {
        font-size: 22px;
        font-weight: bold;
    }

    .dec {
        font-size: 17px;
    }

    .checknow {
        width: 104px;
        height: 36px;
        background: linear-gradient(90deg, #4A9EFF 0%, #1E7FE5 100%);
        box-shadow: 0px 2px 6px 0px rgba(30, 127, 229, 0.25);
        border-radius: 18px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        color: #FFFFFF;
    }

    .priceNum {
        color: #EF4444;
        font-size: 16px;
        margin-left: 8px;
        font-weight: bold;
    }

    .priceName {
        font-weight: bold;
        color: #000;
        font-size: 16px;
    }

    .coachDes {
        font-weight: 500;
        margin-bottom: 8px;
        font-size: 14px;
        color: #9CA3AF;
        line-height: 24px;
        text-align: left;
        margin-top: 8px;
    }

    .label {
        height: 19px;
        box-sizing: border-box;
        padding: 0 5px;
        font-size: 12px;
        color: #007AFF;
        background: #F4F9FF;
        border-radius: 1px 1px 1px 1px;
        line-height: 19px;
        margin-right: 8px;
    }

    .coachName {
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        text-align: left;
        margin-bottom: 8px;
    }

    .coachInfo {
        box-sizing: border-box;
        padding: 12px;
    }

    .coachImg {
        width: 221px;
        height: 220px;
        position: relative;
        cursor: pointer;
    }

    .tag {
        background: linear-gradient(79deg, #F59E0B 0%, #F4870A 100%);
        box-shadow: 0px 2px 8px 0px rgba(255, 71, 87, 0.35);
        height: 30px;
        line-height: 30px;
        border-radius: 15px 15px 15px 2px;
        font-weight: 600;
        font-size: 13px;
        color: #FFFFFF;
        text-align: center;
        box-sizing: border-box;
        padding: 0 11px;
        position: absolute;
        top: 12px;
        left: 12px;
    }

    .coachImg img {
        width: 100%;
        height: 100%;

    }

    .coachItem {
        width: 222px;
        height: 350px;
        background: #fff;
        flex-shrink: 0;
        border-radius: 12px;
        margin-bottom: 20px;
        overflow: hidden;
        box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.25);
    }

    .coaches {
        width: 100%;
        margin: 0 auto;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 10px 30px;
    }
</style>